<template>
    <div class="message-bubble" :class="{ 'own-message text-right': isOwn }">
        <div v-if="message.pictures && message.pictures.length > 0" class="message-images">
            <img v-for="(picture, index) in message.pictures" :key="index"
                :src="picture.startsWith('blob:') ? picture : storageUrl + picture" alt="Message attachment"
                class="message-image-item" />
        </div>

        <p v-if="message.text && message.text !== 'Upload image'" class="message-text">
            {{ message.text }} 
        </p>

        <div v-if="message.sending" class="spinner-border spinner-border-sm text-light" role="status">
            <span class="visually-hidden"></span>
        </div>


        <p v-if="message.error" class="message-status" style="color: red; ">
            {{ $t('status.not_sent') }}
        </p>

        <div class="message-time">{{ message.created_at | moment }}</div>
    </div>
</template>

<script>
import config from "@/config";

export default {
    name: "MessageBubble",
    props: {
        message: {
            type: Object,
            required: true
        },
        isOwn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            storageUrl: config.storageUrl
        };
    }
};
</script>

<style scoped>
.message-bubble {
    max-width: 480px;
    background: white;
    border-radius: 12px;
    border: 1px solid var(--gray-200);
    padding: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.message-bubble.own-message {
    background: var(--color-nz);
    color: white;
}

.message-status {
    font-size: 12px;
    color: var(--gray-100);
}

.message-images {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 8px;
}

.message-image-item {
    max-width: 200px;
    border-radius: 8px;
    cursor: pointer;
    transition: opacity 0.2s;
}

.message-image-item:hover {
    opacity: 0.9;
}

.message-text {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    /* white-space: pre-wrap; */
    word-wrap: break-word;
    color: var(--gray-900);
}

.message-bubble.own-message .message-text {
    color: white;
}

.message-time {
    margin-top: 4px;
    font-size: 11px;
    color: var(--gray-500);
    padding-right: 8px;
}

.message-bubble.own-message .message-time {
    color: rgba(255, 255, 255, 0.7);
}
</style>